import React from 'react';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import styled from 'styled-components';

import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom';

import { Container, Title } from './styles';

const NameTooltip = ({ bgColor, children, placement, title }) => {
  const StyledTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: bgColor || 'grey'
    }
  }));

  return (
    <StyledTooltip
      placement={placement || 'right-end'}
      title={
        <Container>
          <Title as={Typography} variant="body2">
            {title}
          </Title>
        </Container>
      }
      TransitionComponent={Zoom}
    >
      {children}
    </StyledTooltip>
  );
};

export default NameTooltip;
